import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pagination" }

import { computed, onMounted, watch, inject } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { Inspector } from '@/models/inspector.model';
import { useToast } from "vue-toastification";

// Define props if there are any, for this example there are none

// Inject global properties or methods

export default /*#__PURE__*/_defineComponent({
  __name: 'InspectorsPagination',
  setup(__props) {

const actProperty: any = inject('actProperty');

// Using the store
const store = useStore();
const route = useRoute();
// Converted actions from Vuex decorators
const getInspectorsAction = (payload?: { starts_with?: string }): Promise<Inspector[]> => {
  return store.dispatch('inspectors/getInspectors', payload);
};
// Converted data properties
const links = [
  "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", 
  "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "0-9",
];

// Converted methods
const init = async () => {
  await getInspectorsAction({ starts_with: (route.params.search as string) });
};

// Watch for route changes to re-initialize
watch(() => route.params.search, (newVal, oldVal) => {
  if (newVal) {
    init();
  }
});

// Lifecycle hook
onMounted(() => {
  if (route.params.search) {
    init();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link, $index) => {
        return _createElementVNode("li", {
          key: $index,
          class: _normalizeClass(["page-item", { active: _ctx.$route.params.search == link }])
        }, [
          _createVNode(_component_router_link, {
            to: `/inspectorlist/${link}`,
            class: "page-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.toUpperCase()), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 2)
      }), 64))
    ])
  ]))
}
}

})